import { Component, ViewChild, OnInit, OnDestroy } from '@angular/core';
import { MatMenuTrigger } from '@angular/material/menu';
import { AuthService } from '@app/shared/services/auth.service';
import { BuildingsStoreService } from '@app/energy-map/services/buildings-store.service';
import { Router } from '@angular/router';
import { MapHeaderControlsService } from './map-header-controls.service';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';

@Component({
  selector: 'app-map-header-controls',
  templateUrl: './map-header-controls.component.html',
  styleUrls: ['./map-header-controls.component.scss'],
})
export class MapHeaderControlsComponent implements OnInit, OnDestroy {
  protected unsubscribe$: Subject<void> = new Subject<void>();
  @ViewChild('buildingMenuTrigger', ) buildingMenuTrigger?: MatMenuTrigger;
  @ViewChild('userprofileMenuTrigger', { static: true }) userprofileMenuTrigger?: MatMenuTrigger;
  @ViewChild('cogMenuTrigger', ) cogMenuTrigger?: MatMenuTrigger;
  @ViewChild('electricityCostMenuTrigger', )
  electricityCostMenuTrigger?: MatMenuTrigger;
  hasBuildingsWithNoCoordinatesOrType = false;
  isBuildingMenuOpen: boolean = false;
  isUserProfileMenuOpen: boolean = false;
  isElectricityCostMenuOpen: boolean = false;
  isCogMenuOpen: boolean = false;
  isContactMenuOpen: boolean = false;

  constructor(
    public authService: AuthService,
    private buildingsStoreService: BuildingsStoreService,
    private headerCtrlService: MapHeaderControlsService,
    private router: Router
  ) {}

  public ngOnInit(): void {
    this.buildingsStoreService.buildingsWithNoCoordinatesOrTypeCount
      .pipe(takeUntil(this.unsubscribe$))
      .subscribe((x) => (this.hasBuildingsWithNoCoordinatesOrType = x > 0));

    this.headerCtrlService.buildingMenuOpen.pipe(takeUntil(this.unsubscribe$)).subscribe((open) => {
      this.isBuildingMenuOpen = open as boolean;
      if (open) {
        this.buildingMenuTrigger?.openMenu();
      } else {
        this.buildingMenuTrigger?.closeMenu();
      }
    });

    this.headerCtrlService.userProfileMenuOpen.pipe(takeUntil(this.unsubscribe$)).subscribe((open) => {
      this.isUserProfileMenuOpen = open as boolean;
      if (open) {
        this.userprofileMenuTrigger?.openMenu();
      } else {
        this.userprofileMenuTrigger?.closeMenu();
      }
    });

    this.headerCtrlService.cogMenuOpen.pipe(takeUntil(this.unsubscribe$)).subscribe((open) => {
      this.isCogMenuOpen = open as boolean;
      if (open) {
        this.cogMenuTrigger?.openMenu();
      } else {
        this.cogMenuTrigger?.closeMenu();
      }
    });

    this.headerCtrlService.electricityCostMenuOpen.pipe(takeUntil(this.unsubscribe$)).subscribe((open) => {
      this.isElectricityCostMenuOpen = open as boolean;
      if (open) {
        this.electricityCostMenuTrigger?.openMenu();
      } else {
        this.electricityCostMenuTrigger?.closeMenu();
      }
    });
  }

  public ngOnDestroy(): void {
    this.unsubscribe$.next();
    this.unsubscribe$.complete();
  }

  public backToMenu(): void {
    this.router.navigate(['instrumententafel']);
  }

  public onContactMenuToggle(isOpen: boolean): void {
    this.isContactMenuOpen = isOpen;
  }
}
